
const NoItems = () => {
    return (
        <div className="no-payments">
            <h3>
                Ви поки що не надсилали/отримували переказ <span>🤔</span>
            </h3>
            <p>
                Детальніше у підказці вище!
            </p>
        </div>
    );
};

export default NoItems;